<template>
	<div class="o-container on-boarding my-account">
		<global-message v-if="message" v-bind="message"></global-message>
		<div class="o-layout">
			<div class="o-layout__main">
				<div class="white-box o-v-rhythm--small">
					<account-level-view :user="user"></account-level-view>
				</div>
				<div class="white-box o-v-rhythm--small">
					<my-details-view :user="user"></my-details-view>
				</div>
				<!-- <div class="white-box o-v-rhythm--small" v-show="isRegoUser"> -->
				<div class="white-box o-v-rhythm--small">
					<registration-view :user="user"></registration-view>
				</div>
				<preloader-view v-if="emailPreferences.isLoading" class="o-v-rhythm--small"></preloader-view>
				<div class="white-box o-v-rhythm--small" v-else>
					<email-preferences-view
						:all-checkboxes="allCheckboxes"
						:onboarding-checkboxes="onboarding"
						:user="user"
					></email-preferences-view>
				</div>
			</div>
			<div class="o-layout__sidebar">
				<div class="white-box white-box--no-pad">
					<router-link
						class="sidebar-btn"
						:class="{'is-disabled': disabledEdit}"
						:to="{name: 'changePassword'}"
					>Change Password</router-link>
					<router-link
						class="sidebar-btn"
						:class="{'is-disabled': disabledEdit}"
            :to="{name: 'changeEmail'}"
					>Change Email</router-link>
					<a class="sidebar-btn" @click="logout">Sign Out</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import GlobalMessage from '../messages/GlobalMessage.vue';
    import PreloaderView from '../views/PreloaderView.vue';
    import MyDetailsView from '../views/MyDetailsView.vue';
    import EmailPreferencesView from '../views/EmailPreferencesView.vue';
    import RegistrationView from '../views/RegistrationView.vue';
	import AccountLevelView from '../views/AccountLevelView.vue';

    import { mapState, mapGetters } from 'vuex';

    export default {
      components: {
        GlobalMessage,
        PreloaderView,
		AccountLevelView,
        MyDetailsView,
        EmailPreferencesView,
        RegistrationView
      },
      props: {
        message: Object
      },
      data() {
        return {
          emailPreferences: {
            isLoading: false
          },
          errors: {},
          isLoading: false,
          hasUsername: false
        }
      },
      computed: {
        ...mapState('user', {
          user: state => state.user
        }),
        ...mapState('onboarding', {
          onboarding: state => state,
          form: state => state.form || {}
        }),
        ...mapGetters('user', ['identities']),
        ...mapGetters('onboarding', [
          'clubGroupChecked',
          'leagueGroupChecked',
          'grassrootsGroupChecked',
          'checkboxGroupChecked',
          'priorityTicketingChecked',
          'offerGroupChecked'
        ]),
        disabledEdit() {
          return this.identities.length;
        },
        allCheckboxes() {
          return [
            this.clubGroupChecked,
            this.leagueGroupChecked,
            this.grassrootsGroupChecked,
            this.checkboxGroupChecked,
            this.priorityTicketingChecked
          ];
        }
      },
      methods: {
        logout() {
          this.$store.dispatch('user/LOGOUT').then(() => {
            // OAuth path: cognito.js logout() already called window.location.href = buildLogoutUrl()
            // which navigates to auth-ui /logout to clear the SSO session.
            // Calling router.push here would trigger beforeEach → prompt=none SSO redirect,
            // overriding the logout navigation and silently re-authenticating the user.
            if (!window.OAuthConfig?.enabled) {
              this.$router.push({name: 'login'});
            }
          });
        }
      },
      mounted() {
        if (this.user && this.user.username) this.hasUsername = true;

        this.$store.dispatch('onboarding/GET_ONBOARDING_DATA').then(() => {
          this.isLoadingInitial = false;
          this.copyState();
        }).catch(errors => {
          this.errors = errors;

          if (errors instanceof Error) {
            // console.error(errors);
          }
        });
      }
    }

</script>

<style lang="scss">
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";
	@import "~sass/mixins/_attr-bp.scss";
	.my-account {
		.common {
			&__sub-title {
				font-size: 20px;
				font-weight: 600;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.2;
				letter-spacing: normal;
				text-align: left;
				color: #000000;
			}
			&__sub-heading {
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.3;
				letter-spacing: normal;
				text-align: left;
				color: #777777;
			}
			&__heading {
				font-size: 16px;
				font-weight: bold;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.19;
				letter-spacing: 0.32px;
				text-align: left;
				color: #00007d;
			}
		}
		a {
			.btn {
				text-decoration: none;
			}
		}
		.offer-form-group {
			&__container {
				display: -ms-grid;
				display: grid;
				-ms-grid-columns: 32% 32% 32%;
				grid-template-columns: 32% 32% 32%;
				-ms-flex-pack: justify;
				justify-content: space-between;
				@include maxq(tablet) { // max-width: 760px
					grid-template-columns: 100%;
				}
			}
			&__item {
				display: -ms-flexbox;
				display: flex;
				display: -webkit-flex;
				-ms-flex-flow: column;
				flex-flow: column;
				-ms-flex-pack: center;
				justify-content: flex-start;
				-ms-flex-align: center;
				align-items: center;
				max-width: 260px;
				@include maxq(tablet) { // max-width: 760px
					max-width: 100%;
				}
			}
		}
		.offer {
			.rebel-text {
				padding-top: 2px;
				text-transform: lowercase;
				font-size: 12pt;
				font-weight: 600;
			}

			&__inner {
				flex-direction: column;
				border: 1px solid #eaeaea;
			}
			&__rebel-offer-link-button {
				a {
					color: #61a700!important;
					text-transform: uppercase;
					font-family: Gibson;
					font-size: 12px;
					font-weight: 600;
					font-stretch: normal;
					font-style: normal;
					line-height: 1.17;
					letter-spacing: normal;
					text-align: center;
					color: #61a700;
					text-align: center;
					margin: 0;
					background: none;
					border: 0;
					padding: 0;
					z-index: 100;
				}
			}
			&__img-container {
				width: auto;
				height: 170px;
				@include maxq(tablet)  { // max-width: 760px
					height: 360px;
				}
				@include maxq(largeMobile)  { // max-width: 320px
					height: 240px;
				}
				@include maxq(mobile)  { // max-width: 320px
					height: 170px;
				}
			}
			&__txt-container {
				width: 100%;
				padding: 20px;
			}
			&__img {
				-webkit-background-size: contain;
				-moz-background-size: contain;
				-o-background-size: contain;
				background-size: contain;
			}
			&__checkbox {
				position: relative;
				top: inherit;
				right: inherit;
				width: 18px;
				height: 18px;
			}
			&__checkwrapper {
				border-radius: 5px;
				border: solid 1px #BBBBBB;
				display: flex;
				display: -ms-flex;
				display: -webkit-flex;
				flex-direction: row;
				justify-content: center;
				height: 40px;
				padding-top: 11px;
				margin-top: 20px;
			}
			&__redeem {
				margin-left: 10px;
				text-transform: uppercase;
				width: 46px;
				height: 12px;
				font-size: 12px;
				font-weight: 600;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.17;
				letter-spacing: normal;
				text-align: center;
				color: #777777;
				margin-top: 2px;
				display: inline-block;
			}
			&__redeemselected, &__redeemselectedcheck, &__redeemselectedred {
				display: none;
				color: #61a700!important;
				margin-left: 10px;
				text-transform: uppercase;
				width: 46px;
				height: 12px;
				font-size: 12px;
				font-weight: 600;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.17;
				letter-spacing: normal;
				text-align: center;
				margin-top: 2px;
			}
			&__agerange {
				height: 26px;
				border: solid 1px #9ec8e1;
				background-color: #d1e9f6;
				font-size: 10px;
				font-weight: 600;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.82;
				letter-spacing: normal;
				text-align: center;
				color: #3f6a81;
				padding: 4px 0px 4px 0px;
				margin-top: 20px;
				text-transform: uppercase;
			}
			&__description{
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.5;
				letter-spacing: normal;
				text-align: left;
				color: #777777;
				height: 59px;
				overflow: hidden;
			}
			&__txt {
				text-transform: initial;
				font-size: 18px;
				font-weight: 600;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.2;
				letter-spacing: normal;
				text-align: left;
				color: #1e1e1e;
				margin-bottom: 20px;
				height: 42px;
				overflow: hidden;
			}
			&__no-age {
				height: 26px!important;
				display: block;
				position: relative!important;
				background-color: #ffffff!important;
				width: 0px!important;
				margin-top: 20px!important;
			}
		}
		.is-checked {
			.offer__checkwrapper {
				border: solid 3px #61a700;
				padding-top: 8px!important;
			}
			.offer__redeemselected, .offer__redeemselectedred {
				display: inline-block!important;
			}
			.offer__redeem {
				display: none!important;
			}
			&::before {
				box-shadow: none!important;
				-moz-box-shadow: none!important;
				-webkit-box-shadow: none!important;
			}
		}
		.styled-form {
			&__header {
				height: 60px;
				border: solid 1px #61a700;
				background-color: #f7ffeb;
				margin-bottom: 40px;
			}
			&__title {
				font-size: 16px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.5;
				letter-spacing: normal;
				text-align: center;
				color: #61a700;
				padding-top: 15px;
			}
		}
		.club-offers.is-checked {
			.btn--secondary {
				pointer-events: none;
				color: #cccccc;
				border: 2px solid #cccccc;
			}
		}
		.offer.is-checked {
			.offer__redeemselectedcheck {
				display: inline-block;
			}
		}
		.offer.is-disabled {
			.offer__redeemselectedcheck {
				display: none;
			}
		}
	}
	.offer__redeem, .offer__redeemselected, .offer__redeemselectedcheck{
		display: none;
	}
	.offer-remove-btn {
		display:none;
	}
	.offer-disabled-btn {
		pointer-events: none;
	}

</style>
